import { useMutation } from '@tanstack/react-query';
import { ApiResponseError } from '../../../../types/errors';
import { useAccountApi } from '../../hooks/use-settings-api';
import type { UpdatePasswordApiRequest } from '../../types';
import { SettingsPasswordError } from '../errors';

export function useUpdatePassword() {
  const { accountApi } = useAccountApi();

  async function updatePassword(data: UpdatePasswordApiRequest) {
    try {
      await accountApi.updatePassword(data);
    } catch (err) {
      if (ApiResponseError.isApiResponseError(err, ApiResponseError.errorSchemas.message)) {
        if (
          err.status === 422 &&
          err.data.message === 'The provided password does not match your current password.'
        ) {
          throw new SettingsPasswordError('no_match');
        }
      }

      throw err;
    }
  }

  return useMutation({
    mutationFn: updatePassword,
  });
}
